// removed by extract-text-webpack-plugin
module.exports = {"page-row":"SRP__page-row___3rjH4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SRP/SRP.scss
// module id = 191
// module chunks = 0